import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.placeholdersText = this.gettext('Panel name');
        this.item = {panelName: this.panelName};
    }

    submit() {
        this._PanelsService.setPanelName(this.$stateParams.id, this.item.panelName, this.mac)
            .then(() =>{
                this.$state.reload();
                setTimeout(this.popSuccess.bind(this), 400);

            }).catch(err => {
                this.toaster.pop("error", "Error", "Something went wrong please try again later");
        });
    }

    popSuccess(){
        this.toaster.pop("success", "Success", "Saved")
    }

    getTranslatableText(text) {
        return this.LanguageService.getTranslatableText(text);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/details.component/controller.js
 **/